// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "Login_Home_Welcome" + "-legacy." + "b660dbca" + ".js";
};